import { api } from "../../api/endpoints";
import {
    PRODUCTS_FAIL,
    GET_PRICE_FOR_PRODUCT,
    UPDATE_PLAN_PRODUCT_IDS,
    RESET_PRODUCTS_DATA
} from "../constant";


export const getPlanPrices = (productIdsArr) => {
    return async (dispatch) => {
        try {
            productIdsArr.forEach(async (id) => {
                const { data } = await api.post(`/products/getPricesAttachedToProduct`, {productId: id})
                dispatch({
                    type: GET_PRICE_FOR_PRODUCT,
                    payload: {
                        productId: id,
                        prices: data.prices.data
                    }
                })
            })
        } catch (error) {
            dispatch({
                type: PRODUCTS_FAIL
            }); 
        }
    };
};

export const updatePlanProductsIds = (ids) => {
    return async (dispatch) => {
        const idsArray = ids.map(id => {
            return {
                planId: id.id,
                productId: id.value
            }
        })
        try {
            const {data} = await api.post('/products/updatePlanProductsIds', {ids: idsArray})
            dispatch({
                type: UPDATE_PLAN_PRODUCT_IDS,
                payload: data.plans
            })
        } catch (error) {
            dispatch({
                type: PRODUCTS_FAIL
            })
        }
    }
}

export const resetProductsData = () => {
    return async (dispatch) => {
        dispatch({
            type: RESET_PRODUCTS_DATA
        })
    }
}